module.exports = __webpack_public_path__ + "img/twenty.9be976f4.png";